<template>
    <CFormGroup :error="error">
        <CFormCheckbox
            :disabled="disabled"
            :required="required"
            :model-value="value"
            @update:model-value="$emit('input', $event)"
        >
            {{ $t(`rules.community.declare`, lang) }}
            <NuxtLink class="link" target="_blank" :to="{ name: 'pravidla-platformy' }" @click.stop>
                {{ $t(`rules.community.title`, lang) }}
            </NuxtLink>
            {{ $t(`rules.community.commitment`, lang) }}
        </CFormCheckbox>
    </CFormGroup>
</template>

<script setup lang="ts">
defineProps({
    value: {
        type: Boolean
    },
    required: {
        type: Boolean
    },
    error: {
        type: String,
        default: undefined
    },
    lang: {
        type: String,
        default: 'sk'
    },
    disabled: {
        type: Boolean
    }
})

defineEmits(['input'])
</script>
